import { render } from "./NutritionalPropertiesList.vue?vue&type=template&id=b701f752&scoped=true"
import script from "./NutritionalPropertiesList.vue?vue&type=script&setup=true&lang=js"
export * from "./NutritionalPropertiesList.vue?vue&type=script&setup=true&lang=js"

import "./NutritionalPropertiesList.vue?vue&type=style&index=0&id=b701f752&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/SeekingSimple-SSUPR-V3/SeekingSimple-SSUPR-V3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b701f752"],['__file',"resources/js/modules/product-submission/components/filter/NutritionalPropertiesList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b701f752"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b701f752', __exports__)) {
    api.reload('b701f752', __exports__)
  }
  
  module.hot.accept("./NutritionalPropertiesList.vue?vue&type=template&id=b701f752&scoped=true", () => {
    api.rerender('b701f752', render)
  })

}


export default __exports__